import { compose } from 'recompose'
import NewValuePropositionBig from './NewValuePropositionBig'
import isBlackFridayPage from 'helpers/isBlackFridayPage'
import { getLocationPathname } from 'selectors/getPageLocation'
import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
  isBlackFridayPage: isBlackFridayPage(getLocationPathname(state))
})

export default compose(
  connect(mapStateToProps)
)(NewValuePropositionBig)
